import React, { useEffect, useState } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';

import { IContactCard } from '../../types/IContactCard';

import CardWrapper from '../../../ui/card/cardWrapper/cardWrapper';
import Icon from '../../../ui/icon/icon';
import ComponentLoader from '../../../ui/loaders/componentLoader/componentLoader';
import LocationsFilters from './locationsFilter/locationsFilters';

import './contactDetails.scss';

const ContactDetails: React.FC<IContactCard> = ({ profile, loadingProfile }) => {
  const [address, setAddresses] = useState<any>(profile?.addresses[0]);

  const { t } = useTranslate();

  const onChange = (event: any) => {
    setAddresses(event.target.value);
  };

  useEffect(() => {
    setAddresses(profile?.addresses[0]);
  }, [profile]);

  return (
    <CardWrapper className='card-width'>
      <div className='title-flex-wrapper'>
        <span className='card-title'>{t('CONTACTS.CARD_TITLE')}</span>
      </div>
      {loadingProfile ? (
        <ComponentLoader />
      ) : (
        <div className='contact-details-content'>
          <div className='basic-info-content'>
            {profile &&
              profile?.phones.map((phone) => {
                return (
                  <div className='info-row' key={phone?.id}>
                    <Icon name={`far ${phone?.label === 'Mobile' ? 'fa-mobile' : 'fa-phone'}`} className='info-icon' />
                    <span className='info-span'>{t(phone?.label)}</span>
                    <span>{phone?.number}</span>
                  </div>
                );
              })}
            {profile &&
              profile.emails.map((email) => {
                return (
                  <div className='info-row' key={email.id}>
                    <Icon name={`far fa-envelope`} className='info-icon' />
                    <span className='info-span'>{t(email.label)}</span>
                    <span>{email.address}</span>
                  </div>
                );
              })}
          </div>
          {profile && profile.addresses && (
            <div className='basic-info-content content-right'>
              {profile.addresses.length <= 1 ? <span className='info-span-bold'>{t('CONTACTS.BUSSINES')}</span> :
                <LocationsFilters onChange={onChange} addresses={profile && profile.addresses} address={address} />}
              <div className='info-row'>
                <span className='info-span'>{t('CONTACTS.STREET')}</span>
                <span>{address && address.address1}</span>
              </div>
              <div className='info-row'>
                <span className='info-span'>{t('CONTACTS.CITY')}</span>
                <span>{address && address.city}</span>
              </div>
              <div className='info-row'>
                <span className='info-span'>{t('CONTACTS.STATE')}</span>
                <span>{address && address.state}</span>
              </div>
              <div className='info-row'>
                <span className='info-span'>{t('CONTACTS.ZIP')}</span>
                <span>{address && address.postalCode}</span>
              </div>
              <div className='info-row'>
                <span className='info-span'>{t('CONTACTS.COUNTRY')}</span>
                <span>{address && address.country}</span>
              </div>
            </div>
          )}
        </div>
      )}
    </CardWrapper>
  );
};

export default ContactDetails;
